import firebase from 'firebase';
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyB2aQmh0GHR85wCIwI17nzVAh4NTFeIwHY",
    authDomain: "e-clone-417f4.firebaseapp.com",
    projectId: "e-clone-417f4",
    storageBucket: "e-clone-417f4.appspot.com",
    messagingSenderId: "132377331431",
    appId: "1:132377331431:web:d7189516c7c577619c0442",
    measurementId: "G-C8N3QDJM0D"
  };
  const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();
export { db, auth };